import { module } from 'angular';

import { default as imageReaderDirectiveName, ImageReaderDirective } from './image-reader.directive';

export default module('contact.commons.toolbox.image-reader', []).directive(imageReaderDirectiveName, ImageReaderDirective).name;
